const React = require('react');
const TextAlertsPreference = require('components/TextAlertsPreference');
const { usePreferencesHandle } = require('./FieldContext');

const {
    useCallback,
    useEffect,
    useRef
} = React;

const internals = {};

internals.shouldShowTextAlerts = ({ formProps = {} } = {}) => {

    if (!formProps.includePreferences) {
        return false;
    }

    const fieldsToShow = formProps.preferencesFieldsToShow;

    return !Array.isArray(fieldsToShow) || fieldsToShow.includes('sms');
};

module.exports = function TextAlertsPreferenceField(props = {}) {

    const {
        field = {},
        formProps = {}
    } = props;
    const preferencesHandle = usePreferencesHandle();
    const textAlertsRef = useRef(null);

    const setTextAlertsRef = useCallback((nextController) => {

        if (textAlertsRef.current && textAlertsRef.current !== nextController) {
            preferencesHandle?.unregister(textAlertsRef.current);
        }

        textAlertsRef.current = nextController;

        if (nextController) {
            preferencesHandle?.register(nextController);
        }
    }, [preferencesHandle]);

    useEffect(() => () => {

        preferencesHandle?.unregister(textAlertsRef.current);
    }, [preferencesHandle]);

    const handlePreferencesChange = useCallback((preferenceField, value) => {

        if (typeof field.onPreferencesChange === 'function') {
            field.onPreferencesChange({
                field: preferenceField,
                formProps,
                value
            });
        }
    }, [field, formProps]);

    if (!internals.shouldShowTextAlerts({ formProps })) {
        return null;
    }

    return <TextAlertsPreference
        ref={setTextAlertsRef}
        preferences={formProps.signupDetails?.preferences}
        isSignupPage={formProps.mode === 'signup'}
        isEditPage={formProps.mode === 'edit'}
        phoneRequired={!!formProps.requirePhoneForMfa}
        onChange={handlePreferencesChange}
    />;
};

module.exports.internals = internals;
